/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/forbid-prop-types */
import React, { useState, useEffect, useRef } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { uniqueId } from 'lodash';
import { Link } from 'react-router-dom';
import Gravatar from 'react-gravatar';
import WebAudioTrack from 'webaudiotrack-fork-elbywan';
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import store from '../../store';
import PageSpinner from '../../assets/svgs/PageSpinner';
import SendReply from '../../assets/svgs/SendReply';
import QuickAnswers from '../../assets/svgs/QuickAnswers';
import SetQuick from '../../assets/svgs/SetQuick';
import Trash from '../../assets/svgs/Trash';
import Mic from '../../assets/svgs/Mic';
import SendVoice from '../../assets/svgs/SendVoice';
import PlayVoice from '../../assets/svgs/PlayVoice';
import CanselVoice from '../../assets/svgs/CanselVoice';
import StopVoice from '../../assets/svgs/StopVoice';
import RecordVoice from '../../assets/svgs/RecordVoice';
import Navigation from '../Dashboard/Navigation';
import cancelIcon from '../../assets/images/cancel.svg';
import zoomInIcon from '../../assets/images/zoom-in.svg';
import zoomOutIcon from '../../assets/images/zoom-out.svg';
import expandIcon from '../../assets/images/expand.svg';
import arrowRight from '../../assets/svgs/arrow-right.svg';
import {
    getTicket,
    sendTicket,
    deleteReplay,
    sendVoiceTicket
} from '../../actions/Tickets/ticketsActions';
import {
    quickAnswers,
    addQuick
} from '../../actions/QuickAnswers/quickAnswers';
import Back from '../../assets/svgs/Back';

const audioTrack = new WebAudioTrack();

const Single = ({ className, match, history }) => {
    const [isFetch, setFetch] = useState(true);
    const [ticket, setTicket] = useState({});
    const [nextTicketId, setNextTicketId] = useState(null);
    const [replies, setReplies] = useState([]);
    const [quickAnswersList, setQuickAnswers] = useState([]);
    const [ticketResponse, setTicketResponse] = useState('');
    const [showQuickAnswer, setShowQuickAnswer] = useState(false);
    const [recorder, setRecorder] = useState(null);
    const [holdPress, setHoldPress] = useState(0);
    const [showTooltip, setShowTooltip] = useState(false);
    const [recordLengthID, setRecordLengthID] = useState(0);
    const [recordLength, setRecordLength] = useState(0);
    const [toolTipID, setToolTipID] = useState(0);
    const { sites, key } = store.getState().license.active;

    // Records State
    const [disableRecord, setDisableRecord] = useState(false);
    const [disableStop, setDisableStop] = useState(true);
    const [disableCansel, setDisableCansel] = useState(true);
    const [disablePlay, setDisablePlay] = useState(true);
    const [disableSend, setDisableSend] = useState(true);
    const [audioBlob, setBlob] = useState(null);
    const [showMicWrapper, setMicWrapper] = useState(false);

    const [currentSrc, setCurrnetSrc] = useState('');
    const [openLightBox, setOpenLightBox] = useState(false);

    const repliesEl = useRef(null);
    const textAreaEl = useRef(null);
    const answersBoxEl = useRef(null);
    const ToolTipEl = useRef(null);
    const attachModalEl = useRef(null);

    const dispatch = useDispatch();

    const getResponse = (id) => {
        setFetch(true);
        const loader = async () => {
            const response = await dispatch(getTicket(id));
            setTicket(response.ticket);
            setReplies(response.data);
            const quickAnswersResponse = await dispatch(quickAnswers());
            setQuickAnswers(quickAnswersResponse);
            setFetch(false);
            if(response.pagination) {
                setNextTicketId(response.pagination.next);
            }
        };
        loader();
    };

    useEffect(() => {
       getResponse(match.params.id);

        document.addEventListener('click', event => {
            if (!attachModalEl.current) {
                return;
            }

            if (event.target === attachModalEl.current) {
                setOpenLightBox(false);
            }
        });
    }, [match.params.id]);

    useEffect(() => {
        if (!textAreaEl.current || !repliesEl) {
            return;
        }

        textAreaEl.current.style.height =
            textAreaEl.current.scrollHeight > textAreaEl.current.clientHeight
                ? `${textAreaEl.current.scrollHeight}px`
                : '40px';

        repliesEl.current.style.height = `calc(100vh - ${answersBoxEl.current.getBoundingClientRect().height +
        86}px )`;
    }, [ticketResponse]);

    const keyUpHandler = event => {
        setTicketResponse(event.target.value);
    };

    const sendHandler = () => {
        if (!ticketResponse) {
            return;
        }

        setReplies([
            ...replies,
            {
                id: uniqueId('reply-'),
                is_author: true,
                message: ticketResponse
            }
        ]);

        dispatch(sendTicket(match.params.id, 'message', ticketResponse));
        setTicketResponse('');
        textAreaEl.current.style.height = '40px';
    };

    const quickAnswerHandler = answers => {
        setTicketResponse(answers);
        setShowQuickAnswer(false);
    };

    const quickAnswersButtonHandler = () => {
        setShowQuickAnswer(!showQuickAnswer);
    };

    const profileHandler = replay => {
        history.push({ pathname: '/user', state: { ticket } });
    };

    const handleButtonPress = id => {
        setHoldPress(
            setTimeout(() => {
                setShowTooltip(true);
            }, 1000)
        );

        setToolTipID(id);
    };

    const handleButtonRelease = () => {
        clearTimeout(holdPress);
    };

    const closeTooltipHandler = event => {
        if (ToolTipEl.current && !ToolTipEl.current.contains(event.target)) {
            setShowTooltip(false);
        }
    };
    useEffect(() => {
        document.addEventListener('mousedown', closeTooltipHandler);
    }, []);

    const quickAnswerStateHandler = async (state, replayID, content) => {
        if (state === 'delete') {
            setReplies(replies.filter(reply => reply.id !== replayID));
            await dispatch(deleteReplay(match.params.id, replayID));
        } else {
            setQuickAnswers([...quickAnswersList, content]);
            await dispatch(addQuick(content));
        }
    };

    const startVoiceHandler = () => {
        audioTrack.startRecording();
        let length = 0;
        setRecordLengthID(
            setInterval(() => {
                length++;
                setRecordLength(length);
            }, 1000)
        );
        setDisableRecord(true);
        setDisableStop(false);
    };

    const stopVoiceHandler = () => {
        audioTrack.stopRecording(() => {
            setBlob(audioTrack.blob);
        });
        clearInterval(recordLengthID);
        setDisableStop(true);
        setDisableCansel(false);
        setDisablePlay(false);
        setDisableSend(false);
    };

    const playVoiceHandler = () => {
        audioTrack.play();
    };

    const canselVoiceHandler = () => {
        setRecordLength(0);
        setDisableRecord(false);
        setDisableStop(true);
        setDisableCansel(true);
        setDisablePlay(true);
        setDisableSend(true);
    };

    const sendVoiceHandler = () => {
        setReplies([
            ...replies,
            {
                is_voice: '1',
                id: uniqueId(),
                voice_url: window.URL.createObjectURL(audioBlob)
            }
        ]);
        setMicWrapper(false);
        const data = new FormData();
        data.append('voice', audioBlob);
        dispatch(sendVoiceTicket(match.params.id, data));
    };

    const convertTime = num => {
        const min = Math.floor(num / 60);
        const sec = num % 60;

        return `${min < 10 ? '0' : ''}${min}:${sec < 10 ? '0' : ''}${sec}`;
    };

    const attachHandler = src => {
        setCurrnetSrc(src);
        setOpenLightBox(true);
    };

    const dialogBox = () => (
        <div className="AttachModal" ref={attachModalEl}>
            <div style={{ position: 'relative' }}>
                <TransformWrapper
                    defaultScale={1}
                    defaultPositionX={200}
                    defaultPositionY={100}
                >
                    {({ zoomIn, zoomOut, resetTransform, ...rest }) => (
                        <>
                            <TransformComponent>
                                <img src={currentSrc} className="zoom-img" alt="zoom-img" />
                            </TransformComponent>
                            <div className="tools">
                                <button onClick={zoomIn}>
                                    <img src={zoomInIcon} alt="icon"/>
                                </button>
                                <button onClick={zoomOut}>
                                    <img src={zoomOutIcon} alt="icon"/>
                                </button>
                                <button onClick={resetTransform}>
                                    <img src={expandIcon} alt="icon"/>
                                </button>
                            </div>
                        </>
                    )}
                </TransformWrapper>
                <button
                    type="button"
                    className="close-image-btn"
                    onClick={() => setOpenLightBox(false)}>
                    <img src={cancelIcon} alt="icon"/>
                </button>
            </div>
        </div>
    );

    const generateReply = reply => {
        const isAuthor = reply.is_author;
        const isVoice = reply.is_voice === '1';
        let attachs = [];

        if(reply.attach && reply.attach.length > 0 ) {
            attachs = reply.attach;
        }

        return (
            <div>
            <div
                className={`Reply_Item ${isAuthor ? 'isAuthor' : ''} ${
                    reply.id === toolTipID ? 'showTooltip' : ''
                } ${isVoice ? 'isVoice' : ''}`}
                id={reply.id}
                key={reply.id}
                onTouchStart={() => handleButtonPress(reply.id)}
                onTouchEnd={handleButtonRelease}
                onMouseDown={handleButtonPress}
                onMouseUp={handleButtonRelease}
                onMouseLeave={handleButtonRelease}
            >
                {showTooltip && (
                    <div className="Replay__ToolTip" ref={ToolTipEl}>
                        <ul>
                            <li
                                onClick={() =>
                                    quickAnswerStateHandler(
                                        'add',
                                        reply.id,
                                        reply.message
                                    )
                                }
                            >
                                <SetQuick/>
                                اضافه کردن به پاسخ سریع
                            </li>
                            <li
                                onClick={() =>
                                    quickAnswerStateHandler(
                                        'delete',
                                        reply.id,
                                        reply.message
                                    )
                                }
                            >
                                <Trash/>
                                حذف کردن
                            </li>
                        </ul>
                    </div>
                )}
                {(attachs.length) ? (
                    <div style={{display : !(attachs[0].length > 0)  && 'none'}}>
                        <div className="AttachList">
                            {attachs.map(attach => (
                                <img
                                    src={attach}
                                    width="50"
                                    height="50"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => attachHandler(attach)}
                                    alt="attach"
                                />
                            ))}
                        </div>
                    </div>
                ) : null}
                {isVoice ? (
                    <audio controls>
                        <source src={reply.voice_url} type="audio/mpeg"/>
                    </audio>
                ) : (
                    <p dangerouslySetInnerHTML={{ __html: reply.message }}/>
                )}
            </div>
            {openLightBox && dialogBox()}
            </div>
        );
    };

    const generateQuickAnswers = (answers, index) => {
        return (
            <li
                key={index}
                className="Answer"
                onClick={() => quickAnswerHandler(answers)}
            >
                {answers}
            </li>
        );
    };

    return (
        <div className={className}>
            {isFetch ? (
                <div className="Loading">
                    <PageSpinner/>
                </div>
            ) : (
                <>
                    <div className="Single__Header">
                        <div>
                            {nextTicketId &&
                            <button
                                type="button"
                                className="next__btn"
                                onClick={() => {
                                    history.push(`/ticket/${parseInt(nextTicketId)}`);
                                }}
                            >
                                سوال بعدی
                                <Back/>
                            </button>
                            }
                        </div>
                        <div className="Single__Header__info">
                             <Link to="/dashboard">
                                <img
                                    src={arrowRight}
                                    className="back-link"
                                    alt="icon"
                                />
                             </Link>
                            <Gravatar email={ticket.email}/>
                            <div className="Single__Header_Content">
                                <h2 onClick={() => profileHandler(ticket)}>
                                    {ticket.name}
                                </h2>
                                <span>{ticket.cat}</span>
                            </div>
                        </div>
                    </div>
                    <div className="Replies" ref={repliesEl}>
                        {(ticket.attach.length && Array.isArray(ticket.attach)) ? (
                            <>
                                <div className="AttachList">
                                    {ticket.attach.map(attach => (
                                        <img
                                            src={attach}
                                            width="50"
                                            height="50"
                                            style={{ cursor: 'pointer' }}
                                            onClick={() => attachHandler(attach)}
                                            alt="attach"
                                        />
                                    ))}
                                </div>
                                {openLightBox && dialogBox()}
                            </>
                        ) : null}
                        <div className="Reply_Item">
                            <p>{ticket.message}</p>
                        </div>
                        {replies.map(generateReply)}
                    </div>
                    <div className="InputBox" ref={answersBoxEl}>
                        <textarea
                            placeholder="تایپ کنید"
                            onChange={keyUpHandler}
                            value={ticketResponse}
                            ref={textAreaEl}
                        />
                        <button
                            type="button"
                            onClick={quickAnswersButtonHandler}
                        >
                            {showQuickAnswer && (
                                <ul className="QuickAnswers__Wrapper">
                                    {quickAnswersList.map(generateQuickAnswers)}
                                </ul>
                            )}

                            <QuickAnswers/>
                        </button>

                        {ticketResponse ? (
                            <button type="button" onClick={sendHandler}>
                                <SendReply/>
                            </button>
                        ) : (
                            <>
                                <button
                                    type="button"
                                    onClick={() =>
                                        setMicWrapper(!showMicWrapper)
                                    }
                                >
                                    <Mic/>
                                </button>
                            </>
                        )}

                        {showMicWrapper && (
                            <div className="Voice__Tooltip">
                                <span>{convertTime(recordLength)}</span>
                                <button
                                    onClick={startVoiceHandler}
                                    disabled={disableRecord}
                                >
                                    <RecordVoice/>
                                </button>
                                <button
                                    onClick={stopVoiceHandler}
                                    disabled={disableStop}
                                >
                                    <StopVoice/>
                                </button>
                                <button
                                    onClick={canselVoiceHandler}
                                    disabled={disableCansel}
                                >
                                    <CanselVoice/>
                                </button>
                                <button
                                    onClick={playVoiceHandler}
                                    disabled={disablePlay}
                                >
                                    <PlayVoice/>
                                </button>
                                <button
                                    disabled={disableSend}
                                    onClick={sendVoiceHandler}
                                >
                                    <SendVoice/>
                                </button>
                            </div>
                        )}
                    </div>
                </>
            )}
        </div>
    );
};

Single.propTypes = {
    className: PropTypes.string.isRequired,
    match: PropTypes.any.isRequired
};

export default styled(Single)`
    display: flex;
    flex-direction: column;
    min-height: 100%;
    position: relative;

    .Loading {
        position: absolute;
        top: 50%;
        left: 50%;
        margin: 0 auto;
        transform: translateY(-50%) translateX(-50%);
    }

    + ${Navigation} {
        display: none !important;
    }

    .Single__Header {
        display: flex;
        justify-content: space-between;
        flex-flow: row-reverse;
        align-items: center;
        background: rgb(19, 189, 239);
        padding: 2em 2.0625em 1em 2.0625em;

        .Single__Header_Content {
            margin-right: 8px;
        }

        .Single__Header__info {
            display: flex;
            align-items: center;

            > img {
                width: 32px;
                height: 32px;
                border-radius: 50%;
            }

            h2 {
                color: #ffffff;
                font-size: 16px;
                line-height: 28px;
                font-weight: bold;
            }

            span {
                font-size: 12px;
                color: #c6e7f1;
                font-weight: 300;
                line-height: 21px;
            }
            
            .back-link {
                width: 10px;
                height: 18px;
                margin-left: 10px;
                cursor: pointer;
            }
        }
    }

    .Replay__ToolTip {
        position: absolute;
        top: 50%;
        transform: translateY(-15%);
        background: #fff;
        z-index: 9;
        border-radius: 5px;
        left: -15px;
        box-shadow: 1px 1px 2px #646a931a;
        padding: 7px 12px;
    }

    .Replies {
        height: calc(100vh - 186px);
        padding: 30px 30px 15px 30px;
        overflow: auto;
        background: #f5f6f8;
    }

    .Reply_Item {
        margin-bottom: 30px;
        position: relative;

        &.isVoice {
            padding: 10px;
            background: #bcffe2;

            > audio {
                width: 100%;
            }
        }

        &.showTooltip {
            .Replay__ToolTip {
                opacity: 1;
            }
        }

        .Replay__ToolTip {
            opacity: 0;

            li {
                font-size: 10px;
                color: #000946;
                line-height: 17px;
                font-weight: 400;
                padding: 7px 0px;
                cursor: pointer;

                > svg {
                    margin-left: 9px;
                }

                &:last-child {
                    color: rgba(255, 39, 39, 1);
                }
            }
        }

        span {
            display: block;
            text-align: left;
            font-size: 14px;
            color: #0d1fa1;
            line-height: 25px;
            font-weight: bold;
            margin-bottom: 20px;
            cursor: pointer;
        }

        > p {
            position: relative;
            background: #eff1ff;
            padding: 20px;
            border-radius: 10px;
            font-size: 12px;
            font-weight: 400;
            line-height: 21px;
            color: #0d1fa1;

            &:before {
                content: '';
                width: 0;
                height: 0;
                border-left: 10px solid transparent;
                border-right: 10px solid transparent;
                border-bottom: 10px solid #eff1ff;
                position: absolute;
                top: 1px;
                left: 25px;
                transform: translateY(-100%);
            }
        }

        &.isAuthor {
            span {
                text-align: right;
            }

            > p {
                background: #bcffe2;

                &:before {
                    right: 25px;
                    left: auto;
                    border-bottom-color: #bcffe2;
                }
            }
        }
    }

    .InputBox {
        position: relative;
        padding: 30px;
        display: flex;
        flex-flow: row wrap;
        align-items: flex-start;
        background: #f5f6f8;

        > button {
            position: relative;
            border: none;
            padding: 0;
            width: 40px;
            height: 40px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: transparent;
        }

        textarea {
            flex: 1;
            border-radius: 20px;
            overflow: hidden;
            resize: none;
            border: 1px solid #8f99dc;
            box-shadow: 0 3px 10px #e8ebff;
            background: #fff;
            color: #8f99dc;
            font-size: 14px;
            font-weight: 300;
            line-height: 25px;
            padding: 6px 17px;
            min-height: 40px;
            height: 40px;
            overflow-y: auto;
            max-height: 200px;

            &:-moz-placeholder {
                color: #8f99dc;
            }

            &::-webkit-input-placeholder {
                color: #8f99dc;
            }
        }
    }

    .QuickAnswers__Wrapper {
        position: absolute;
        top: -20px;
        transform: translateY(-100%);
        background: #ffffff;
        box-shadow: 0 3px 10px #e8ebff;
        cursor: pointer;
        padding: 20px 22px;
        border-radius: 4px;
        width: 280px;
        left: -41px;
        height: 30vh;
        overflow: auto;
        box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);

        &:after {
            content: '';
            position: absolute;
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 10px 10px 0 10px;
            border-color: #ffffff transparent transparent transparent;
        }

        .Answer {
            width: 100%;
            overflow: hidden;
            max-height: 43px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            text-overflow: -o-ellipsis-lastline;
            text-align: right;
            font-size: 10px;
            font-weight: 400;
            line-height: 17px;
            background: #f7f7f7;
            border-radius: 4px;
            padding: 8px 10px;
            margin-bottom: 16px;

            &:last-child {
                margin-bottom: 0;
            }
        }
    }

    .Voice__Tooltip {
        display: flex;
        flex-flow: row wrap;
        align-items: center;
        background: #8f99dc;
        padding: 4px 9px;
        position: absolute;
        top: -20px;
        left: 30px;
        border-radius: 6px;

        span {
            color: #fafafa;
            font-size: 14px;
            line-height: 25px;
            font-weight: 300;
        }

        > button {
            background: #fff;
            padding: 0;
            border: none;
            width: 21px;
            height: 21px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 50%;
            margin-right: 24px;

            &[disabled] {
                opacity: 0.5;
            }
        }

        &:after {
            content: '';
            position: absolute;
            width: 0;
            height: 0;
            border-style: solid;
            border-width: 9px 6px 0 6px;
            border-color: #8f99dc transparent transparent transparent;
            bottom: 0;
            left: 14px;
            transform: translateY(100%);
        }
    }

    .AttachModal {
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 999;
        background: rgba(0, 0, 0, 0.8);

        img.zoom-img {
            max-width: 100%;
            height: auto;
            max-height: 500px;
            display: block;
            margin: 0 auto;
        }
        
        .close-image-btn {
          position: absolute;
          top: 8px;
          right: 10px;
          background-color: transparent;
          padding: 0;
          border: none;
          cursor: pointer;
          
          img {
              width: 30px;
              height: 30px;
          }
          
        }
    }
    
    .tools {
       text-align: center;
      
         button {
             margin: 5px 5px 10px 0;
             padding: 6px 8px;
             background: #eff1ff;
             border: 1px solid #eff1ff;
             border-radius: 4px;
         }
         
         img {
            width: 19px;
            height: 19px;
        }
    }

    .AttachList {
        background: #eff1ff;
        margin-bottom: 10px;
        padding: 15px;
        border-radius: 5px;

        > img {
            margin-left: 10px;
            border-radius: 5px;
        }
    }
    
    .next__btn {
        display: flex;
        justify-content:center;
        border: 1px solid white;
        color: white;
        background: transparent;
        font-size: 12px;
        width: 90px;
        height: 26px;
        align-items: center;
        border-radius: 6px;
        white-space: nowrap!important;
        
        svg {
            height: 18px!important;
            width: 18px!important;
            margin-right: 6px;
        }
    }
`;
